export default {
  trigger: 'Zaproś właściciela restauracji',
  title: 'Zaproś właściciela restauracji',
  description:
    'Utwórz konto dla właściciela restauracji. Otrzyma e-mail z tymczasowym hasłem, aby się zalogować i dokończyć konfigurację restauracji.',
  fields: {
    first_name: 'Imię',
    last_name: 'Nazwisko',
    email: 'E-mail',
  },
  buttons: {
    invite: 'Wyślij zaproszenie',
    cancel: 'Anuluj',
  },
  toasts: {
    invited: '{{email}} został(a) zaproszony/-a do dokończenia konfiguracji.',
    failed: 'Nie udało się utworzyć konta właściciela. Spróbuj ponownie.',
  },
};
